import React from 'react'
import { Link } from 'react-router-dom'

export default function HomeSustainable() {
  return (
    <>
      <section className="home-sustain">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12 col-lg-6">
              <div className="sustain-content">
                <div className="wow animate__animated animate__slideInLeft" data-wow-delay="0.1s" data-wow-duration="1.2s">
                  <h2 className="heading">Committed to <br /> Clean, Sustainable Operations</h2>
                  <p>At Supershine, sustainability is central to our design and engineering philosophy. We build Industrial laundry solutions that minimize water, energy and chemical consumption while maximizing long-term efficiency.</p>
                  <p>Through responsible sourcing, optimized layouts, and eco-friendly technologies, we help businesses adopt cleaner, future-ready operations that reduce environmental impact and deliver lasting value. Our systems are engineered to lower operational waste and extend equipment lifespan, ensuring responsible resource use.</p>
                  <div className="btn-sec"> <Link className="default-btn" to="/contact"><span >Enquire Now</span></Link></div>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-6">
              <div className="sustain-image">
                <img src="/assets/images/commited-img.webp" alt="Commited" className="commited img-responsive" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
